/*
 * SPDX-FileCopyrightText: 2024 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { SemanticPathService } from '@spartacus/core';
import { OrderFacade } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class KbOrderConfirmationGuard  {
    constructor(
        protected orderFacade: OrderFacade,
        protected router: Router,
        protected semanticPathService: SemanticPathService
    ) { }

    canActivate(): Observable<boolean | UrlTree> {
        return this.orderFacade.getOrderDetails().pipe(
            map((orderDetails) => {
                return true;

            })
        );
    }
}
